(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__textBlockExpandInit) return;
    window.__textBlockExpandInit = true;

    const updateTruncatedState = (wrapper) => {
      if (!wrapper.classList.contains('text-block-wrapper--collapsible') || wrapper.classList.contains('is-expanded')) {
        return;
      }

      const textBlock = wrapper.querySelector('.text-block');
      if (!textBlock) return;

      wrapper.classList.toggle('is-truncated-false', textBlock.scrollHeight <= textBlock.clientHeight + 1);
    };

    document.querySelectorAll('.text-block-wrapper--collapsible').forEach(updateTruncatedState);

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-text-block-toggle]');
      if (!button) return;

      const wrapper = button.closest('.text-block-wrapper--collapsible');
      if (!wrapper) return;

      const isExpanded = wrapper.classList.toggle('is-expanded');
      button.setAttribute('aria-expanded', String(isExpanded));
    });

    window.addEventListener('resize', () => {
      document.querySelectorAll('.text-block-wrapper--collapsible:not(.is-expanded)').forEach(updateTruncatedState);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
